import CookiesPage from './CookiesPage';

export default CookiesPage; 